"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cross = exports.dot = exports.multiple = exports.add = exports.unit = exports.norm = void 0;
function norm(vec) {
    return Math.sqrt(Math.pow(vec.x, 2) + Math.pow(vec.y, 2) + Math.pow(vec.z, 2));
}
exports.norm = norm;
function unit(vec) {
    var n = norm(vec);
    return {
        x: vec.x / n,
        y: vec.y / n,
        z: vec.z / n,
    };
}
exports.unit = unit;
function add(vec1, vec2) {
    return {
        x: vec1.x + vec2.x,
        y: vec1.y + vec2.y,
        z: vec1.z + vec2.z,
    };
}
exports.add = add;
function multiple(vec, scaler) {
    return {
        x: vec.x * scaler,
        y: vec.y * scaler,
        z: vec.z * scaler,
    };
}
exports.multiple = multiple;
function dot(vec1, vec2) {
    return vec1.x * vec2.x + vec1.y * vec2.y + vec1.z * vec2.z;
}
exports.dot = dot;
function cross(vec1, vec2) {
    return {
        x: vec1.y * vec2.z - vec1.z * vec2.y,
        y: vec1.z * vec2.x - vec1.x * vec2.z,
        z: vec1.x * vec2.y - vec1.y * vec2.x,
    };
}
exports.cross = cross;
